import React from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {Button, Modal, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {PaymentDoubleBookedModalProps} from './PaymentDoubleBookedModalProps'

const StyledModal = styled(Modal)`
  width: 100%;
  max-width: ${convertUnit(290)};
  padding: ${convertUnit(20)};
  display: flex;
  flex-direction: column;
  gap: ${convertUnit(20)};
  justify-content: center;
  align-items: center;
  text-align: center;
`

const StyledTitle = styled(Paragraph)`
  margin-bottom: ${convertUnit(10)};
`

const StyledButton = styled(Button)`
  width: 100%;
`

const StyledDivider = styled.div`
  height: ${convertUnit(2)};
  background-color: ${({theme}) => theme.gray_1};
  width: 100%;
`

export default function PaymentDoubleBookedModal({
  visible,
  onContinue,
  toggleModal,
}: PaymentDoubleBookedModalProps) {
  const {translate} = useTranslation()

  return (
    <StyledModal visible={visible} onBackdropPress={toggleModal}>
      <div>
        <StyledTitle fontSize="xl" fontWeight="bold">
          {translate('transaction:cartDoubleBookedTitle')}
        </StyledTitle>
        <Paragraph fontSize="l">
          {translate('transaction:cartDoubleBookedDescription')}
        </Paragraph>
      </div>
      <StyledDivider />
      <Paragraph fontSize="l" fontWeight="bold">
        {translate('transaction:paymentIssue')}
      </Paragraph>
      <StyledButton
        label={translate('transaction:repeatOrder')}
        onClick={onContinue}
      />
      <StyledButton
        label={translate('global:cancel')}
        backgroundHoverColor="white_3"
        backgroundColor="white_2"
        color="primary_5"
        onClick={toggleModal}
      />
    </StyledModal>
  )
}
